import axios, { AxiosResponse } from "axios";
import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Dimmer, Loader, Tab } from "semantic-ui-react";
import { AdminContext} from "../../contexts/AdminContext";
import { SettingsContext } from "../../contexts/SettingsContext";
import { config } from "../../contexts/UrlContext";
import ErrorPage from "../ErrorPage/ErrorPage";
import Appearance from "./Appearance";
import Email from "./Email";
import General from "./General";
import License from "./License";
import TableConfig from "./TableConfig";
import LogSettings from "./LogSettings";
import OpenIdConfig from "./OpenIdConfig";
import AuthContext from "../../contexts/AuthContext";
import { getRequest } from "../../services/axiosService";

function Admin() {

    const { auth } = useContext(AuthContext);

    const [emailSettings, setEmailSettings] = useState(null);
    const [generalSettings, setGeneralSettings] = useState(null);
    const [licenseSettings, setLicenseSettings] = useState(null);
    const [tableSettings, setTableSettings] = useState(null);
    const [logSettings, setLogSettings] = useState(null);
    const [loading, setLoading] = useState(true);

    const { hasAdminPrivileges } = useContext(SettingsContext);

    useEffect(() => {
        async function getSettings() {

            await getEmailSettings();
            await getAdminSettings();
            await getTableSettings();
            await getLicenseSettings();
            await getLogSettings();
            setLoading(false)
        }
        getSettings();
        
    }, [])

    const getEmailSettings = async () => {
        try {
            let response: AxiosResponse = await getRequest(auth, `/Admin/GetEmailSettings`);
            setEmailSettings(response.data)
        } catch (error) {
            console.log(error);
            toast.error(`Unable to retrieve Settings`);
        }
    }

    const getAdminSettings = async () => {
        try {
            let response: AxiosResponse = await getRequest(auth, `/Admin/GetGeneralSettings`);
            setGeneralSettings(response.data)
        } catch (error) {
            console.log(error);
            toast.error(`Unable to retrieve Settings`);
        }
    }

    const getTableSettings = async () => {
        try {
            let response: AxiosResponse = await getRequest(auth, `/Admin/GetTableSettings`);
            setTableSettings(response.data)
        } catch (error) {
            console.log(error);
            toast.error(`Unable to retrieve Settings`);
        }
    }

    const getLicenseSettings = async () => {
        try {
            let response: AxiosResponse = await getRequest(auth, `/ContentManager/GetLicenseSettings`);
            setLicenseSettings(response.data)
        } catch (error) {
            console.log(error);
            toast.error(`Unable to retrieve Settings`);
        }
    }
    const getLogSettings = async () => {
        try {
            let response: AxiosResponse = await getRequest(auth, `/Admin/GetLogSettings`);
            setLogSettings(response.data)
        } catch (error) {
            console.log(error);
            toast.error(`Unable to retrieve Settings`);
        }
    }

    if (loading) {
        return (
            <Dimmer inverted active={true}>
              <Loader inverted>Loading CM2WebShare...</Loader>
            </Dimmer>
        );
    } else if (!hasAdminPrivileges) {
        return (
            <ErrorPage title="Access Denied" message="Only Administrators and Records Managers and whitelisted users can view this page" />
        )
    } else { 
        return (
            <div className="admin-tabs slide-in-right" id="mainContent" style={{ marginTop: "30px", width: "58%", marginRight: "auto", marginLeft:"auto", paddingTop: "20px" }}>
                <AdminContext.Provider 
                    value={{
                        emailSettings: emailSettings,
                        setEmailSettings: setEmailSettings,
                        generalSettings: generalSettings,
                        setGeneralSettings: setGeneralSettings,
                        tableSettings: tableSettings,
                        setTableSettings: setTableSettings,
                        licenseSettings: licenseSettings,
                        setLicenseSettings: setLicenseSettings,
                        logSettings: logSettings,
                        setLogSettings: setLogSettings
                    }}
                   >
                    <AdminTabs />
                </AdminContext.Provider>
            </div>
        )
    }
}

const panes = [
    {
        menuItem: 'General', render: () =>
            <Tab.Pane>
                <General />
            </Tab.Pane>
    },
    {
        menuItem: 'Appearance', render: () =>
            <Tab.Pane>
                <Appearance />
            </Tab.Pane>
    },
    {
        menuItem: 'Email', render: () =>
            <Tab.Pane >
                <Email />
            </Tab.Pane>
    },
    {
        menuItem: 'License', render: () =>
            <Tab.Pane>
                <License />
            </Tab.Pane>
    },
    {
        menuItem: 'Tables', render: () =>
            <Tab.Pane>
                <TableConfig />
            </Tab.Pane>
    },
    {
        menuItem: 'Log Management', render: () =>
            <Tab.Pane>
                <LogSettings />
            </Tab.Pane>
    },
    {
        menuItem: 'Open ID', render: () =>
            <Tab.Pane>
                <OpenIdConfig />
            </Tab.Pane>
    }
]

const AdminTabs = () => <Tab panes={panes} />

export default Admin;